<template>
  <Select
    class="ts-select"
    popper-class="ts-select-popper"
    v-bind="$attrs"
    :filterable="filterable"
    v-on="$listeners"
    :class="{ filterable }"
  >
    <slot></slot>
  </Select>
</template>

<style lang="scss" scoped>
.ts-select::v-deep {
  box-shadow: inset -5px -5px 10px 0 #fafbff, inset 5px 5px 10px 0 #a6abbd;
  border-radius: 47px;

  &.el-select {
    .el-select__caret {
      color: #6d7587;
      font-size: 18px;
    }

    &.el-select--small,
    &.el-select--mini {
      .el-select__caret {
        font-size: 14px;
      }

      .el-input__inner {
        border-radius: 16px;
        line-height: 18px;
        padding: 6px 16px;

        &::placeholder {
          font-size: 12px;
        }
      }

      &.filterable {
        .el-input__inner {
          padding-left: 40px;
        }
      }

      .el-select__tags {
        &::before {
          content: url(/magnifier.svg);
          margin-left: 12px;
        }
      }

      .el-tag {
        border-radius: 8px;
        background-image: linear-gradient(286deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
        background-blend-mode: soft-light, normal;
        background-clip: padding-box;
        box-shadow: inset 2px 2px 6px 0 #a6abbd, inset -2px -2px 6px 0 #fafbff;
        border: solid 2px rgba(255, 255, 255, 0.4);

        .el-select__tags-text {
          font-family: Roboto;
          font-size: 12px;
          color: #6d7588;
        }

        &.el-tag--mini {
          height: 22px;
        }
      }
    }

    &.el-select--mini {
      .el-input__inner {
        border-radius: 16px;
        line-height: 18px;
        padding: 4px 16px;
        font-size: 12px;

        &::placeholder {
          font-size: 12px;
          line-height: 18px;
          color: #6d7587;
        }
      }
    }

    &.filterable {
      .el-input__inner {
        background: #ebecf0;
        background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
        background-blend-mode: soft-light, normal;
        background-clip: padding-box;
        border: 2px solid rgba(255, 255, 255, 0.4);
        box-shadow: inset -5px -5px 10px 0 #fafbff, inset 5px 5px 10px 0 #a6abbd;
      }
    }

    .el-input__inner {
      box-shadow: 5px 5px 10px 0 rgba(166, 171, 189, 0.48), -5px -5px 10px 0 rgba(250, 251, 255, 0.8);
      border: solid 2px rgba(255, 255, 255, 0.16);
      background-blend-mode: soft-light, normal;
      background-clip: padding-box;
      background: #ebecf0;
      background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);

      border-radius: 47px;

      font-family: Roboto;
      font-size: 16px;

      height: auto;
      padding: 6px 16px;

      &::placeholder {
        font-family: Roboto;
        font-size: 16px;
        font-weight: normal;
        line-height: 40px;
        color: #6d7587;
      }

      &:focus {
        border: solid 2px #99ffd1;
      }
    }
  }
}
</style>

<style lang="scss">
.ts-select-popper {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.32);
  box-shadow: -6px -6px 16px 0 rgba(250, 251, 255, 0.4), 6px 6px 16px 0 rgba(166, 171, 189, 0.4);
  border-radius: 13px;

  box-sizing: border-box;
  padding: 4px;

  .popper__arrow {
    &::after {
      border-color: transparent !important;
    }
  }

  .el-select-dropdown__item {
    border: 2px solid transparent;

    font-family: Roboto;
    font-size: 12px;
    color: #6d7587;

    &.hover {
      background: #ebecf0;
      background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
      background-blend-mode: soft-light, normal;
      background-clip: padding-box;
      border: 2px solid rgba(255, 255, 255, 0.16);
      box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
      border-radius: 20px;

      color: #242424;
    }
  }

  &.el-select-dropdown.is-multiple {
    .el-select-dropdown__item.selected {
      background: #ebecf0;
      background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
      background-blend-mode: soft-light, normal;
      background-clip: padding-box;
      border: 2px solid rgba(255, 255, 255, 0.16);
      box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
      border-radius: 20px;

      color: #242424;
    }
  }
}
</style>

<script>
import { Select } from 'element-ui';

export default {
  name: 'TsSelect',
  components: {
    Select
  },
  props: {
    filterable: {
      type: Boolean,
      default: false
    }
  }
};
</script>
